import { Spinner } from "react-bootstrap";
/**
 * @deprecated use components from shared/ui instead
 */
function Loader({ children, className = "", ...props }) {
  return (
    <span className={`  d-flex align-items-center gap-3 ${className}`}>
      <Spinner animation="border" {...props} />
      {children}
    </span>
  );
}

export default Loader;
